import type { AuthProvider } from '@refinedev/core';
import Cookies from 'js-cookie';
import { removeToken } from './core/auth/utils';

export const TOKEN_KEY = 'refine-auth';
export const authProvider: AuthProvider = {
  login: async ({ username, email, password }) => {
    if ((username || email) && password) {
      localStorage.setItem(TOKEN_KEY, email);
      return {
        success: true,
        redirectTo: '/blog-posts',
      };
    }

    return {
      success: false,
      error: {
        name: 'LoginError',
        message: 'Invalid username or password',
      },
    };
  },
  logout: async () => {
    localStorage.removeItem(TOKEN_KEY);
    Cookies.remove('accessToken');
    Cookies.remove('userData');
    localStorage.removeItem('colorMode');
    removeToken();
    return {
      success: true,
      redirectTo: '/login',
    };
  },
  check: async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      return {
        authenticated: true,
      };
    }

    return {
      authenticated: false,
      redirectTo: '/login',
    };
  },
  getPermissions: async () => null,
  getIdentity: async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      return {
        id: 1,
        name: token,
      };
    }
    return null;
  },
  onError: async (error) => {
    // eslint-disable-next-line no-console
    console.error(error);
    return { error };
  },
};
